module.exports = __webpack_public_path__ + "static/media/location_default.52fed948.jpg";